import React, { useState } from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyleSheet, Text, IconButton } from '@gopeerproject/ui-kit';
export const ChartFrame = ({ title, description, caption, children, tooltip, height, style }) => {
    const styles = useStyleSheet(getStyles);
    const [showTooltip, setShowTooltip] = useState(false);
    return (React.createElement(View, { style: [style, height ? { height } : { height: 200 }] },
        title ? (React.createElement(View, { style: styles.titleContainer },
            React.createElement(Text, { type: 'body', size: 'lg', weight: 'regular' }, title),
            tooltip ? (React.createElement(View, { style: styles.tooltip__container },
                React.createElement(IconButton, { size: 'xxs', type: 'secondary', accent: 'neutral', value: 'info', onPress: () => {
                        setShowTooltip(!showTooltip);
                    } }),
                React.createElement(View, { style: [styles.tooltip, showTooltip && { display: 'flex' }] },
                    React.createElement(Text, { type: 'headline', size: 'md' }, title),
                    React.createElement(Text, { type: 'body', weight: 'regular', size: 'sm', style: styles.tooltip__label }, tooltip)))) : null)) : null,
        description !== undefined ? (React.createElement(Text, { type: 'heading', style: styles.description, size: 'h6' }, description)) : null,
        caption !== undefined ? (React.createElement(Text, { type: 'body', size: 'sm', style: styles.caption, weight: 'regular' }, caption)) : null,
        children));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    titleContainer: {
        flexDirection: 'row',
        marginBottom: size.B,
        alignItems: 'center'
    },
    description: {
        minHeight: size.J
    },
    caption: {
        marginTop: size.C,
        color: color.invert2.p56,
        minHeight: size.H
    },
    tooltip: {
        zIndex: 99,
        display: 'none',
        backgroundColor: color.bg.v3,
        borderRadius: size.G,
        padding: size.D,
        position: 'absolute',
        margin: 'auto',
        top: `calc(100% + ${size.B}px)`,
        width: '260px',
        shadowColor: 'rgba(28, 29, 40, 0.1)',
        shadowOffset: { width: 0, height: 8 },
        shadowRadius: 42
    },
    tooltip__container: {
        paddingLeft: size.C
    },
    tooltip__label: {
        color: color.invert2.p42
    }
}));
//# sourceMappingURL=ChartFrame.js.map